module.exports = __webpack_public_path__ + "static/media/PlainInstance.4a082a53.svg";